import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";

const DEFAULT_MESSAGE = "Hi Shine Fabric, I have a query about your products.";

function toWaNumber(phone) {
  if (!phone) return "";
  // Strip everything except digits; WhatsApp expects country-code + number, no plus.
  const digits = String(phone).replace(/\D/g, "");
  return digits;
}

export default function WhatsAppFloat() {
  const [phone, setPhone] = useState("");
  const location = useLocation();

  useEffect(() => {
    api.get("/site-content")
      .then((r) => setPhone(r.data?.contact_phone || ""))
      .catch(() => {});
  }, []);

  // Hide on admin/admin-login routes to keep dashboard clean
  if (location.pathname.startsWith("/admin")) return null;

  const wa = toWaNumber(phone);
  if (!wa) return null;

  const href = `https://wa.me/${wa}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-4 right-4 sm:bottom-5 sm:right-5 z-40 group flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white rounded-full shadow-2xl shadow-emerald-500/30 transition-all duration-300 ease-out hover:scale-105 active:scale-95 p-3 sm:p-3.5"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping" aria-hidden="true" />
      <MessageCircle className="w-6 h-6 relative" strokeWidth={2.25} />
      <span className="relative hidden sm:inline-block max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-[max-width,padding] duration-300 ease-out group-hover:max-w-[140px] group-hover:pr-2">
        Chat with us
      </span>
    </a>
  );
}
